"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isString: function() {
        return isString;
    },
    isObject: function() {
        return isObject;
    }
});
function isString(value) {
    return typeof value === "string";
}
function isObject(value) {
    return value !== null && typeof value === "object";
}

//# sourceMappingURL=utils.js.map